import src from "IMAGE";
export default { src, width: 99, height: 109, blurWidth: 0, blurHeight: 0};
